export const openInNewTab = (url:string) => {
  const win = window.open(url, '_blank');

  if (win.focus) {
    win.focus();
  }
};
